import { Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';

const dropdown = styled(Dropdown).attrs((props) => ({
  fontSize: props.fontSize || props.theme.fontSize.text,
}))`
  font-size: ${(props) => props.fontSize};
  font-family: Roboto;
  color: #4D5473;
  &&.ui.dropdown .menu>.header {
    color: #4D5473;
  }
  &&.ui.dropdown .menu>.item > span{
    font-family: Roboto;
    color: #4D5473;
  }
  &.ui.inline.dropdown>.text {
    font-weight: 500;
  }
`;

export default dropdown;
